import React from "react";
import { Modal } from "react-bootstrap";
import Resources from "../../../types/Resources";
import ChecklistRadioOptions from "../../Common/ChecklistRadioOptions";
import ScaffoldingWorkChecklistFormState from "../../../types/forms/Permits/Conditions/ScaffoldingWorkChecklistFormState";

type ScaffoldingWorkChecklistModalProps = {
    resources: Resources;
    formState: ScaffoldingWorkChecklistFormState;
    onChange: (fn: (prevValue: ScaffoldingWorkChecklistFormState) => ScaffoldingWorkChecklistFormState) => void;
    show: boolean;
    onHide: () => void;
    canManageContent: boolean;
};

function ScaffoldingWorkChecklistModal({
    resources,
    formState,
    onChange,
    show,
    onHide,
    canManageContent
}: ScaffoldingWorkChecklistModalProps) {
    function changeHandler(key: keyof ScaffoldingWorkChecklistFormState, value: any) {
        onChange((prevValue) => {
            const updatedFormState: ScaffoldingWorkChecklistFormState = {
                ...prevValue,
                [key]: {
                    ...prevValue[key],
                    value
                }
            };

            return updatedFormState;
        });
    }

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("ScaffoldingWorkChecklist")}</h1>
            </Modal.Header>
            <Modal.Body>
                <ul className="list-unstyled">
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="has-approved-validity-certificate"
                            labelText={resources.get("HasApprovedValidityCertificate")}
                            onChange={(updatedValue) => changeHandler("hasApprovedValidityCertificate", updatedValue)}
                            resources={resources}
                            value={formState.hasApprovedValidityCertificate.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="has-sufficiently-high-guard-rails"
                            labelText={resources.get("HasSufficientlyHighGuardRails")}
                            onChange={(updatedValue) => changeHandler("hasSufficientlyHighGuardRails", updatedValue)}
                            resources={resources}
                            value={formState.hasSufficientlyHighGuardRails.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="has-toeboards"
                            labelText={resources.get("HasToeboards")}
                            onChange={(updatedValue) => changeHandler("hasToeboards", updatedValue)}
                            resources={resources}
                            value={formState.hasToeboards.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="has-loose-planks"
                            labelText={resources.get("HasLoosePlanks")}
                            onChange={(updatedValue) => changeHandler("hasLoosePlanks", updatedValue)}
                            resources={resources}
                            value={formState.hasLoosePlanks.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-risk-of-stepping-through"
                            labelText={resources.get("IsRiskOfSteppingThrough")}
                            onChange={(updatedValue) => changeHandler("isRiskOfSteppingThrough", updatedValue)}
                            resources={resources}
                            value={formState.isRiskOfSteppingThrough.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-back-protection-mounted-if-ladder-above-4m"
                            labelText={resources.get("IsBackProtectionMountedIfLadderAbove4m")}
                            onChange={(updatedValue) => changeHandler("isBackProtectionMountedIfLadderAbove4m", updatedValue)}
                            resources={resources}
                            value={formState.isBackProtectionMountedIfLadderAbove4m.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="are-escape-routes-cleared"
                            labelText={resources.get("AreEscapeRoutesCleared")}
                            onChange={(updatedValue) => changeHandler("areEscapeRoutesCleared", updatedValue)}
                            resources={resources}
                            value={formState.areEscapeRoutesCleared.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="has-scaffolding-damage"
                            labelText={resources.get("HasScaffoldingDamage")}
                            onChange={(updatedValue) => changeHandler("hasScaffoldingDamage", updatedValue)}
                            resources={resources}
                            value={formState.hasScaffoldingDamage.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="has-oil-spill"
                            labelText={resources.get("HasOilSpill")}
                            onChange={(updatedValue) => changeHandler("hasOilSpill", updatedValue)}
                            resources={resources}
                            value={formState.hasOilSpill.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="has-ice"
                            labelText={resources.get("HasIce")}
                            onChange={(updatedValue) => changeHandler("hasIce", updatedValue)}
                            resources={resources}
                            value={formState.hasIce.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                </ul>
            </Modal.Body>
        </Modal>
    );
}

export default ScaffoldingWorkChecklistModal;
